// @flow

export { default as mitb } from './mitb.png';
export { default as litb } from './litb.png';
export default '';
